import Yup from 'helpers/yup'

/**********************************************************************************************************
 *   SCHEMA START
 **********************************************************************************************************/
export const RoleSchema = Yup.object({
    id: Yup.number().required(),
    name: Yup.string().oneOf(['Account Holder', 'Developer', 'Billing', 'Admin']).required()
})
